export const no = {
  message: {
    overtime: {
      title: 'Overtid',
      from: 'Fra',
      to: 'Til',
      fifty: 'Overtid 50%',
      hundred: 'Overtid 100%',
      total: 'Totalt',
      entries: 'Oppføringer',
      noEntries: 'Ingen overtid i denne perioden.'
    },
    egenmelding: {
      title: 'Egenmelding',
      report: 'Meld inn egenmelding',
      type: 'Type',
      own: 'Egen sykdom',
      child: 'Sykt barn',
      startDate: 'Fra dato',
      days: 'Dager',
      instances: 'tilfeller',
      remaining: 'Gjenstår',
      exhausted: 'Kvote oppbrukt',
      ownDaysHint: 'Maks 3 kalenderdager per tilfelle',
      send: 'Send inn',
      reported: 'Egenmelding registrert',
      quotaExceeded: 'Dette overskrider gjenværende kvote',
      tooManyDays: 'Overskrider gjenværende dager'
    },
    flex: {
      title: 'Fleksitid',
      balance: 'Fleksitidssaldo',
      asOf: 'Per',
      policy: 'Regelsett',
      transactions: 'Transaksjoner',
      transactionHistory: 'Transaksjonshistorikk',
      noTransactions: 'Ingen transaksjoner ennå.',
      avspasering: 'Avspasering',
      requestAvspasering: 'Søk avspasering',
      myRequests: 'Mine søknader',
      noRequests: 'Ingen avspaseringssøknader ennå.',
      startDate: 'Fra dato',
      endDate: 'Til dato',
      hours: 'Timer',
      minutes: 'Minutter',
      comment: 'Kommentar',
      date: 'Dato',
      type: 'Type',
      change: 'Endring',
      submit: 'Send søknad',
      cancelRequest: 'Trekk søknad',
      confirmCancel: 'Vil du trekke denne avspaseringssøknaden?',
      requestSubmitted: 'Avspaseringssøknad sendt!',
      requestCancelled: 'Søknad trukket.',
      overtimeRegistered: 'Overtid registrert',
      overtime: 'Overtid',
      toFlexAccount: 'Til flekskonto (grunntimer)',
      paidSupplement: 'Utbetalt tillegg',
      sendToFlex: 'Send til flekskonto',
      payOut: 'Utbetal',
      decideLater: 'Bestem senere',
      decideNow: 'Bestem nå',
      flexChoice: 'Fleksvalg',
      choiceSaved: 'Valget er lagret.',
      noPendingLines: 'Ingen ventende overtid å ta stilling til.',
      choice: {
        pending: 'Venter',
        flex: 'Flekskonto',
        payout: 'Utbetalt'
      },
      state: {
        pending: 'Venter',
        approved: 'Godkjent',
        denied: 'Avslått',
        cancelled: 'Trukket'
      },
      txType: {
        accrual: 'Opptjening',
        withdrawal_avspasering: 'Avspasering',
        cap_excess_to_overtime: 'Over tak → overtid',
        cap_excess_dropped: 'Over tak → bortfalt',
        rollover: 'Overført',
        payout: 'Utbetalt',
        expire: 'Bortfalt',
        adjustment_manual: 'Manuell justering'
      }
    },
    dashboard: {
      edit: 'Rediger',
      done: 'Ferdig',
      reset: 'Tilbakestill',
      theme: 'Tema',
      darkMode: 'Mørk modus',
      featured: 'Utvalgte',
      allModules: 'Alle moduler',
      dragToFeature: 'Dra moduler hit for å fremheve dem',
      editHint: 'Dra for å omorganisere · endringer lagres automatisk',
      editHintFeatured: 'Dra en modul opp for å fremheve · dra ned for å fjerne',
      editHintBento: 'Dra for å omorganisere · trykk ⤢ for å endre størrelse · lagres automatisk',
      layoutTiles: 'Fliser',
      layoutSections: 'Seksjoner',
      layoutBento: 'Bento',
      sectionWork: 'Arbeid',
      sectionResources: 'Ressurser',
      sectionInfoMore: 'Info og mer',
      modules: 'Moduler',
      customizeModules: 'Tilpass moduler'
    },
    layout: {
      login: 'Logg inn',
      logout: 'Logg ut',
      rfidsignin: 'Logg på med RFID',
      SignInpassword: 'Logg på med passord',
      ScanRFID: 'Skann RFID-brikken din',
      ortext: 'ELLER',
      dashboard: 'Dashbord',
      timer: 'Time Management',
      projects: 'Prosjekter',
      stemp: 'Stemple',
      calendar: 'Kalender',
      deviation: 'Avvik',
      home: 'Hjem',
      deliver: 'Levere',
      more: 'Mer',
      files: 'Dokumenter',
      equipments: 'Utstyr',
      checklists: 'Sjekklister',
      drawing: 'Tegninger',
      pressureTestReport: 'Trykktest rapport',
      weldlog: 'Sveiselogg',
      event: 'begivenhet',
      ndt: 'NDT',
      surfaceReport: 'Overflate rapport',
      technicalReport: 'Teknisk rapport',
      matrialList: 'Materialliste',
      pwht: 'PWHT',
      pwps: 'PWPS',
      wps: 'WPS',
      warehouse: 'Lager',
      tasks: 'Oppgaver',
      orders: 'Bestillinger',
      facilities: 'Anlegg',
      chemicallist: 'Stoffkartotek',
      nbselftL: 'NB! Self created',
      asbuilt: 'AS-bygget',
      autoLogout: 'Auto utlogging'
    },
    login: {
      language: 'Språk',
      back: 'Tilbake',
      userName: 'Bruker',
      password: 'Passord',
      authFailed: 'Innlogging feilet !',
      networkError: 'Får ikke kontakt med serveren. Sjekk tilkoblingen og vertsnavnet.',
      invalidCredentials: 'Feil brukernavn eller passord !',
      serverError: 'Serveren kunne ikke fullføre innloggingen. Kontakt support.',
      host: 'Domene',
      forgotPassword: 'Glemt passord?',
      forgotPasswordHint: 'Skriv inn e-postadressen din nedenfor for å tilbakestille passordet ditt.',
      backToLogin: 'Tilbake til innlogging',
      emailAddress: 'E-postadresse',
      resetMyPassword: 'Tilbakestill Passordet Mitt'
    },
    common: {
      pwaNotEnabled: 'PWA er ikke aktivert, vennligst kontakt administrator',
      delete_row: 'Slett rad',
      install: 'Legg til snarvei på hjemmesiden for hurtig tilgang.',
      justTab: 'Trykk på',
      addToHome: 'deretter <Legg til hjemmeside>',
      english: 'Engelsk',
      norwegian: 'Norsk',
      lithuanian: 'Lithuanian', // need
      polish: 'Polish', // need
      swedish: 'Swedish', // need
      save: 'Lagre',
      saveAndClose: 'Lagre & lukk',
      send: 'Send',
      edit: 'Edit',
      cancel: 'Avbryt',
      update: 'Oppdater',
      delete: 'Slett',
      updateAndClose: 'Oppdater & lukk',
      close: 'Lukk',
      new: 'ny',
      isActive: 'Is active',
      addNew: 'Legg til ny',
      savedSuccess: 'Saved successfully!',
      addedSucess: 'Lagt til!',
      updatedSuccess: 'Oppdatert!',
      deleteSuccess: 'Slettet!',
      errorOccured: 'En feil oppstod !',
      backToList: 'Tilbake',
      search: 'Søk',
      yes: 'Ja',
      no: 'Nei',
      isDefault: 'Is Default',
      loadingMsg: 'Loading, Please wait',
      deleteConfirm: 'Vil du slette?',
      areYouSure: 'Er du sikker på at du vil slette?',
      validationIssue: 'Vennligst sjekk de nødvendige feltene!',
      total: 'Total',
      noResults: 'Ingen treff!',
      statusUpdateFailed: 'Status ble ikke lagret. Prøv igjen.',
      increaseHeight: 'Øk høyden',
      decreaseHeight: 'Reduser høyden',
      others: 'Others',
      typeHere: 'Type here...',
      position: 'Position',
      color: 'Color',
      maxCharacters: 'Max {charCount} characters',
      changedPassword: 'Password Changed Successfully',
      import: 'Import',
      note: 'Note',
      invalidEmail: 'Ugyldig epost',
      no_records: 'Ingen opptak funnet!',
      no_data: 'Ingen data tilgjengelig',
      ok: 'Ok',
      date: 'Dato',
      comments: 'Kommentar',
      draftMsg: 'Saved as Draft',
      createProjectRole: 'Create Project Role',
      updateProjectRole: 'Update Project Role',
      module: 'Module',
      selectTemplate: 'Select Template',
      documentTemplate: 'Document Template',
      download: 'Nedlasting',
      uploadedSuccess: 'Uploaded successfully !',
      weekTotalHours: 'Week hrs',
      addWorktype: 'Legg til Arbeidstype',
      updateWorktype: 'Oppdater Arbeidstype',
      worktype: 'Arbeidstype',
      newUpdate: 'Ny oppdatering tilgjengelig!',
      refresh: 'Oppdater', // Forfriske
      retry: 'Prøv igjen',
      somethingWentWrong: 'Noe gikk galt',
      online: 'Tilkoblet',
      offline: 'Offline',
      moduleName: 'Module Name',
      updatedOn: 'Updated On',
      columns: 'Columns',
      confirmCancel: 'Confirm Cancel',
      areYouSureCancel: 'Are you sure you want to cancel ?',
      not_approved_notification: 'Hei! {count} timeregistrering(er) i uke {weeknumber} er ikke godkjent',
      hourExceedNotification: 'Registrerte timer overstiger 24 timer.',
      options: 'Options',
      label: 'Label',
      value: 'Value',
      confirmStatusChange: 'Confirm Status change',
      areYouSureToChangeStatus: 'Er du sikker på at du vil endre status til {statusText} ?',
      complete: 'fullstendig',
      incomplete: 'ufullstendig',
      name: 'Navn',
      number: 'Nummer',
      noPermission: "Sorry! You don't have permission to {permissionType} {module}",
      charsLimit35: 'Maksimalt {length} tegn',
      confirmAddHour: 'Skiftet er fullført!',
      sureToAddExceedingHour: 'Registrerte timer overskrider arbeidstiden. Er du sikker på at du vil legge til?',
      warning: 'Varsel!',
      required: 'Kreves',
      timerFeatureDisabled: 'Timer feature disabled',
      locationNotSet: 'Location not set',
      type: 'Type',
      changeVideoSource: 'Change video source',
      permissionDenied: 'Kamera tillatelse har blitt nektet! Aktiver det i nettleserinnstillingene!',
      time: 'Time',
      orderno: 'Best.nr',
      ready_for_production: 'Klar for produksjon',
      production: 'Produksjon',
      on_hold: 'On hold',
      finished: 'Ferdig',
      of: 'av',
      ndt_percentage_error: 'NDT-prosent må ha 0 til 100',
      lengthError: 'Lengden må være mindre enn 10',
      update_properties: 'Oppdater egenskaper',
      add_properties: 'Legg til egenskaper',
      preparing_fields: 'Klargjør felt...',
      from_attributs: 'SKJEMAATRIBUTTER',
      enter_title: 'Skriv inn tittelen på hver kolonne:',
      loading_grid: 'Laster rutenett...',
      from_properties: 'FORM EGENSKAPER',
      dragging: 'Dra...',
      catch_up: 'Alle tok igjen!!!',
      add_header: 'Legg til topptekst',
      add_footer: 'Legg til bunntekst',
      drop_fields: 'Slipp feltene her',
      for_header: 'FOR OVERSKRIFT',
      for_footer: 'FOR bunntekst',
      add_html: 'LEGG TIL HTML-INNHOLD',
      relate: 'Forhold',
      unrelate: 'Ikke relatert',
      values: 'Verdier',
      scan: 'Skann',
      filename: 'Filnavn',
      fitToScreen: 'Tilpass til skjermen',
      actualSize: 'Faktisk størrelse',
      zoomIn: 'Zoom inn',
      zoomOut: 'Zoom ut',
      reset: 'Nullstille',
      doYouWantContinue: 'Vil du fortsatt fortsette?',
      stempHint: 'Hvis du velger skiftliste, kan du starte stempelet',
      hoursExeed: 'over 24 timer',
      on: 'På',
      reachedHours: 'Nådde 24 timer',
      invaliHours: 'Ugyldige timer',
      notValidNumber: 'Ikke gyldig nummer',
      invalidName: 'Ugyldig navn',
      filterSaveResult: 'Søk lar deg se filteret du har brukt, og det filtrerte resultatet kan bare sees i rapporten hvis du lagrer sjekklisten',
      seemsInvalid: 'Timer ser ut til å være ugyldige!',
      shiftContinue: 'Stamtimen din fortsetter...',
      no_fields_found: 'Finner ingen sjekklistefelt',
      sharePoint: 'Sharepoint Feil brukernavn og passord eller feil i konfigurasjonen.',
      dragAndDropTips: 'Lagring er obligatorisk ved hvert dra og slipp for å unngå feilplassering av rader',
      afterCopyFilter: 'Filteraksjon vil bli utført til du lagrer sjekklisten',
      archived: 'Arkivert',
      datagrid_filter_help_text_1: 'Resultatene vil bli filtrert på samme måte som forrige gangs filteralternativer.',
      datagrid_filter_help_text_2: 'Når du legger til en ny rad, vil filtre bli fjernet og alle rader vil bli lagt til.',
      datagrid_filter_help_text_3: 'Filtre skiller ikke mellom store og små bokstaver, så vi kan bruke både store og små bokstaver.',
      datagrid_filter_help_text_4: 'Vi kan ikke filtrere samme kolonne to ganger.',
      datagrid_filter_help_text_5: 'Dra og slipp vil bli endret av filterresultatet, hvis brukeren lagrer sjekklisten.',
      datagrid_filter_help_text_6: 'Tekstområdet filtrert av ordet mellom hvilken som helst del av setningen.',
      datagrid_filter_help_text_7: 'Det er obligatorisk å fylle ut både felt og verdien for å utføre filterhandling.',
      sharepointCharacters: "Dette feltet skal ikke inneholde noen av disse tegnene '*:<>?/\\|.'",
      company: 'Selskap',
      filenotfound: 'Filen ble ikke funnet',
      folder: 'Mappe',
      folders: 'Mapper',
      files: 'Filer',
      emptyFolder: 'Denne mappen er tom',
      emptyFolderHint: 'Publiserte dokumenter vises her',
      gridView: 'Rutenettvisning',
      listView: 'Listevisning',
      back: 'Tilbake',
      searchResults: 'Søkeresultater',
      previousDocument: 'Forrige dokument',
      nextDocument: 'Neste dokument',
      imagedraw: 'Tegne på bilde'
    },
    timer: {
      stop: 'Stop',
      ga_til_time: 'Gå til timeliste',
      minutes: 'minutter',
      start: 'Start',
      place: 'Sted',
      hours: 'Timer',
      activity: 'Aktivitet',
      inactive_suffix: '(inaktiv)',
      not_linked_warning: 'Denne føringen overføres ikke til {integration} — noe er ikke koblet',
      pause: 'Pause',
      from: 'Fra',
      till: 'Til',
      shift: 'Skiftliste',
      startTime: 'Starttid',
      endTime: 'Sluttid',
      editHours: 'Rediger',
      approved: 'Godkjent',
      notApproved: 'Ikke godkjent',
      delivered: 'Levert',
      notDelivered: 'Ikke levert',
      year: 'År',
      week: 'Uke',
      nonBillable: 'Ikke fakturerbart',
      hourlogging: 'Fakturerbar',
      noHours: 'Ingenting å levere !',
      deliveredMsg: 'Timene ble levert',
      addHours: 'Før timer',
      deliverHours: 'Lever timer',
      hoursExceeding: 'Timer Exceeded 8 hours',
      cancelTimer: 'Cancel Timer',
      uploadSuccess: 'Upload Success',
      picture: 'Take a Picture',
      imageNeeded: 'Please upload a picture before you stop the timer!',
      nonbillableworktype: 'Ikke fakturerbart',
      additionalWorktype: 'Tilleggs arbeidstype',
      additional_hours: 'Tillegg (enheter)',
      overtimeToFlex: 'Send overtid til flekskonto',
      switchProject: 'Bytt prosjekt',
      reasonForSwitchingProject: 'Årsak for å bytte prosjekt',
      projectSwitchedSuccessfully: 'Prosjekt byttet suksessfullt',
      failedToSwitchProject: 'Kunne ikke bytte prosjekt',
      selectDifferentProject: 'Vennligst velg et annet prosjekt'
    },
    projects: {
      chatOpen: 'Åpne',
      chatEditMembers: 'Rediger deltakere',
      chatEditMembersHint: 'Kryss av for hvem som skal være med i samtalen. Den som legges til kan lese hele historikken.',
      chatCreate: 'Opprett',
      chatParticipants: 'Deltakere',
      chatNewPrivate: '+ Ny',
      chatSend: 'Send',
      chatPrivate: 'Privat',
      chatSeenBy: 'Sett av {count}',
      chatSent: 'Sendt',
      chatEveryone: '{count} deltakere · alle med prosjekttilgang',
      chatPrivateOnly: 'Bare {names} kan se denne samtalen',
      chatNewPrivateTitle: 'Ny privat samtale',
      chatNewPrivateHint: 'Velg hvem som kan se denne samtalen.',
      chat: 'Chat',
      chatConversations: 'Samtaler',
      chatEmpty: 'Ingen meldinger ennå.',
      chatPlaceholder: 'Skriv en melding...',
      chatOpenWeldMapping: 'Åpne sveisekartlegging',
      chatYou: 'deg',
      chatEdited: 'redigert',
      chatConfirmDelete: 'Slette denne meldingen?',
      chatToday: 'I dag',
      chatYesterday: 'I går',
      startDate: 'Startdato',
      endDate: 'Sluttdato',
      projectNo: 'Prosjektnr.',
      projectname: 'Prosjektnavn',
      aoRanked: 'AO Ranked',
      workOrderName: 'Arbeidsordrenavn',
      all: 'Alle',
      allActive: 'Alle Aktive',
      myAll: 'Alle mine',
      myActive: 'Mine aktive',
      project: 'Prosjekt',
      customer: 'Kunde',
      status: 'Status',
      noActiveProjects: 'No Active Projects!',
      selectProject: 'Velg Prosjekt',
      projectMaterialDisabled: 'Materialer deaktivert for dette prosjektet',
      drawingGroup: 'Tegnegruppe',
      sectionIdentification: 'Identifikasjon',
      sectionStatusAttachments: 'Status og vedlegg',
      sectionReportDetails: 'Rapportdetaljer'
    },
    calendar: {
      today: 'I dag',
      month: 'Måned',
      day: 'Dag',
      weekNotExists: 'Uken eksisterer ikke',
      yearValid: 'Må være fire sifre',
      valid: 'Må være gyldig',
      yearTooLessValidation: 'År må være større enn 1920',
      weekLock: 'Valgte datoer er i en låst uke',
      dayLocked: 'Valgt dato er i en låst uke',
      otherHourEntries: 'Andre timeregistreringer'
    },
    shifts: {
      shift: 'Mine vakter',
      documents: 'Dokumenter:',
      not_found: 'Ingen notater eller dokumenter funnet.',
      notValidPausedTime: 'Pausetiden er lengre enn skifttiden',
      continue: 'Fortsette',
      clear: 'Klar',
      shiftEndsAt: 'Skiftet slutter kl.'
    },
    deviation: {
      deviations: 'Avvik',
      register_deviation: 'Registrer Avvik',
      view_deviation: 'View Deviation',
      high: 'Høy',
      medium: 'Medium',
      low: 'Lav',
      closed: 'Lukket',
      registered: 'Registrert',
      process: 'Behandling',
      actions: 'Handlinger',
      title: 'Tittel',
      reported_by: 'Rapportert av',
      location: 'Lokasjon',
      reason: 'Årsak',
      document: 'Dokument',
      category: 'Avvikskategori',
      estimate_cost: 'Estimert kost',
      severity: 'Alvorlighetsgrad',
      deviation_status: 'Avvik status',
      deadline: 'Tidsfrist',
      description: 'Beskrivelse',
      responsible: 'Ansvarlig',
      copyto: 'Kopi til',
      upload_files: 'Last opp',
      required_message: 'Feltet er obligatorisk',
      consequences: 'Konsekvenser',
      changeRequest: 'Endringsmelding',
      hse: 'HMS',
      deviation_number: 'Avviksnummer',
      underlying_reason: 'Underliggende grunn',
      corrective_actions: 'Korrigerende tiltak',
      effect_of_measures: 'Effekt av tiltak',
      sectionRegistration: 'Registrering',
      sectionClassification: 'Klassifisering',
      sectionFollowUp: 'Oppfølging',
      sectionWhatHappened: 'Hva skjedde',
      sectionCorrectiveAction: 'Korrigerende tiltak',
      sectionAttachments: 'Vedlegg',
      readonlyNotice: 'Du har ikke tilgang til å redigere dette avviket. Feltene vises kun til informasjon.'
    },
    checklist: {
      title: 'Sjekkliste',
      updateChecklist: 'Oppdater sjekkliste',
      pickCheckList: 'Velg en sjekkliste',
      addCheckList: 'Legg sjekkliste',
      hmsKs: 'HMS/KS',
      templateName: 'Malnavn',
      checklist_recipients: 'E-postmottaker',
      checklist_recipient_hint: 'Skriv inn e-post med komma(,) separert.',
      projectnr: 'PO nr.',
      projectname: 'Prosjektnavn',
      aonr: 'AO nr.',
      workordername: 'AO navn',
      customer: 'Kunde',
      customercontact: 'Kunde kontakt',
      projectleader: 'Prosjektleder',
      importCSV: 'Importer CSV',
      CSVFileInfo: 'Her kan du importere data fra en csv-fil til en sjekkliste.',
      removeRow: 'Fjern 1. rad hvis den har overskrifter.',
      sameOrederColumn: 'Sørg for at kolonnene er i samme rekkefølge som du har definert i sjekklisten.',
      semicolonDelimiter: 'Bruk semikolon som csv-skilletegn.',
      withoutImport: 'Uten import',
      addCSVFile: 'Legg til CSV-fil',
      report_header: 'Report header',
      copy_confirm: 'Do you want to copy the checklist?',
      filter: 'Filter',
      apply: 'Søke om',
      image: 'Bilde',
      no_comment: 'Ingen kommentar',
      action: 'Handling',
      cameraCapture: 'Ta bilde',
      openCamera: 'Åpne kamera',
      takePhoto: 'Ta bilde',
      uploadDocument: 'Åpne kamera og last opp dokument',
      retake: 'Ta på nytt'
    },
    equipments: {
      equipment: 'Utstyr',
      addEquipment: 'Legge til utstyr',
      updateEquipment: 'Utstyr',
      viewEquipment: 'View Equipment',
      active: 'Aktive',
      quarantine: 'Karantene',
      discarded: 'Discarded',
      warrantydate: 'Garantidato',
      dateofPurchase: 'Kjøpsdato',
      vendor: 'Leverandør',
      modelNumber: 'Modellnummer',
      product: 'Produkt',
      serialNumber: 'Serienummer',
      capacity: 'Kapasitet',
      groups: 'Grupper',
      plannedCalibration: 'Planlagt kalibrering',
      scrapDate: 'Kassert dato',
      equipmentNumber: 'Utstyr nummer',
      placement: 'Plassering',
      notifyByEmail: 'Varsling på e-post',
      mustAllocateToProjectOrLocation: 'Må tilordne utstyret til enten prosjekt eller sted.',
      confirm: 'Er du sikker?'
    },
    customModule: {
      modules: 'Moduler',
      customModule: 'Egendefinert modul',
      customModules: 'Egendefinerte moduler',
      uploadDocument: 'Last opp dokument',
      isCompleted: 'Fullført',
      add: 'Legge til',
      urlNotFound: 'URL-en ble ikke funnet',
      completed: 'Fullført',
      notCompleted: 'Ikke fullført',
      fileSizeLimitMsg: 'Filstørrelsesgrensen overskredet for en eller flere filer (maksgrense {maxSize}MB).',
      invalidFileType: 'Filtype ikke tillatt'
    },
    moduleReports: {
      title: 'Modulrapporter',
      chartyAxis: 'Number Of Records (per module)'
    },
    projectFeature: {
      drawingNumber: 'Tegnings nr.',
      poRanked: 'PO nr.',
      operator: 'Operator',
      reportNumber: 'Report nr.',
      uploadNdtDocument: 'Last opp NDT-dokument',
      aoRanked: 'AO nr.',
      NDTSpecifications: 'NDT Spesifikasjon',
      NDTScope: 'NDT Omfang',
      filterMaterials: 'Tilsett materiale',
      chargedLotNumber: 'Charge/Lot nr.',
      selectFiles: 'Velg filer',
      createdOn: 'Opprettet dato',
      weldingID: 'Sveise ID',
      weldNumber: 'Sveise nr.',
      wpsNumber: 'WPS nr.',
      wpsAsComma: 'Skriv inn WPS-nr. Som komma skilt.',
      weldEnd: 'Sveising slutt',
      vtSignDate: 'VT Sign./Dato',
      rtSignDate: 'RT Sign./Dato',
      utSignDate: 'UT Sign./Dato',
      mtPtSignDate: 'MT/PT Sign./Dato',
      createdDate: 'Opprettet Dato',
      tegNr: 'Teg nr.',
      tegNrWpsNr: 'Teg nr. / Wps nr.',
      posNr: 'Pos nr.',
      batchNr: 'Batch nr.',
      heatNr: 'Heat nr.',
      onStock: 'På lager',
      weldingConsumable: 'Sveisetilsett',
      registerBatchAgainstWps: 'Registrer batchnr. mot en WPS, for sveiseloggen',
      out: 'Uttak',
      sectionIdentification: 'Identifikasjon',
      sectionStock: 'Lager',
      sectionStatus: 'Status og vedlegg',
      descriptionHint: 'Beskrivelse',
      recordNumber: 'Skiver nr.',
      chartSpeed: 'Kart hastighet',
      chartNumber: 'Kartnr.',
      unrestrictedTo: 'Ubegrenset til',
      restrictedRateOfRise: 'Begrenset økning til',
      holdTemperatureRequired: 'Holde temperatur',
      holdTemperatureActual: 'Faktiske holdetempratur',
      holdTimeActual: 'Faktiske holdetid',
      holdTimeRequired: 'Holdetid',
      restrictedRateDown: 'Begrenset hastighet ned',
      unrestrictedRateOfFall: 'Ubegrenset temperaturfall fra',
      weldDate: 'Sveise dato',
      performedBy: 'Utført av',
      approvedBy: 'Godkjent av',
      approvedDate: 'Godkjent dato',
      weldLogDate: 'Sveisedato',
      productNumber: 'Prod.nr',
      weldLength: 'Sveiselengde (mm)',
      designation_1: 'Del 1 Betegnelse',
      designation_2: 'Del 2 Betegnelse',
      thickness_1: 'Tykkelse 1 (mm)',
      thickness_2: 'Tykkelse 2 (mm)',
      weld_diameter: 'Diameter (mm)',
      notAccepted: 'Ikke akseptert',
      ndtStatus: 'Ndt status',
      isDiameter: 'Rør',
      ndt: '%NDT',
      weldingCompound: 'Fugetype',
      batch_lot: 'Batc/lot',
      choose: 'velg',
      pipe_description: 'Rørbeskrivelse'
    },
    whsDashboard: {
      scanText: 'Skann ordrenummer eller strekkode',
      customerOrder: 'Kundeordre',
      receiveSupplierOrder: 'Motta leverandørordre',
      adjustmentOrders: 'Justeringsordre',
      transferOrders: 'Overføringsordre',
      cycleCount: 'Varetelling',
      product: 'Produkter',
      supplierOrder: 'Innkjøpsordre',
      returnOrder: 'Returordre'
    },
    ccsheet: {
      warehouse: 'Lager',
      created: 'Opprettet',
      counted: 'Telt',
      count: 'Telle',
      reCount: 'Telle om',
      closeComplete: 'Lukk og fullfør',
      unit: 'Enh',
      stock: 'Lager',
      scanLocation: 'Skann eller skriv inn lokasjon',
      nextLoc: 'Neste lok',
      info: 'Melding!',
      continueCount: 'Fortsett å telle',
      clearAndRecount: 'Nullstill og telle om',
      completeRecount: 'Fullfør omtelling',
      ccsheetComplete: 'Telleskjema vil bli fullført. Vil du fortsette?',
      noSheetFound: 'Ingen telleskjema funnet!',
      noProductOnLocation: 'Ingen produkter funnet på denne lokasjonen!',
      stockTake: 'Telling har blitt fullført for denne lokasjonen. Ønsker du å forsette med denne lokasjonen eller nullstille data og telle om igjen?',
      ccsheetAddProduct: 'Produkt ligger ikke i telleskjema. Vil du legge til?'
    },
    product: {
      supplierartno: 'Leverandørens artikkelnummer',
      supplier: 'Leverandørnavn',
      barcode: 'Strekkode',
      noProductFound: 'Ingen produkter funnet!',
      minQty: 'Min.ant.',
      orderQty: 'Best.ant.',
      qty: 'Mottat qty',
      batch: 'Batch Nr',
      scanLoc: 'Velg Lok',
      noLocFound: 'Ingen lokasjon funnet!'
    },
    order: {
      products: 'Produkter',
      avail: 'Benytte',
      ordered: 'Rekke.',
      received: 'Motta.',
      pickedQty: 'Pic.',
      pickOrder: 'Velg ordre',
      delivery: 'levere',
      rest: 'Rest',
      complete: 'Ferdig',
      pick: 'Hente',
      pickProducts: 'Velg produkter',
      scanProduct: 'Skann strekkode for et produkt',
      scanBatch: 'Skann batchnummer',
      picked: 'Hentet',
      toPick: 'Skal hentes',
      location: 'Lok',
      pickLocation: 'Velg lokasjon',
      qtyExceeds: 'Antall overskrider',
      noOrderFound: 'Ingen ordre funnet!',
      notValidBatch: 'Batchnummer er ugyldig!',
      receiveOrder: 'Motta ordre',
      receive: 'Mottat',
      batchExists: 'Batchnummer eksisterer allerede!',
      receiveWarning: 'Vil du legge til {qty} stk {product} på lager?',
      completedSuccess: 'Completed successfully!',
      addFreight: 'Vil du legge til frakt ?',
      cost: 'Kostnad',
      price: 'Pris',
      orderedQtyHigh: 'Antall mottatt er høyere enn bestilt, vil du fortsette?  ( Ja / Nei )',
      collect: 'samle inn',
      receiving: 'Receiving',
      availableToPick: 'Avail qty(s) to receive',
      adjust: 'Adjust',
      orderComplete: 'Order will be completed. Continue?',
      orderDate: 'bestillingsdato'
    },
    tasks: {
      forYour: 'For din',
      information: 'Informasjon',
      acknowledge: 'Bekreft',
      review: 'Revider',
      approval: 'Godkjenning',
      subject: 'Emne',
      dueDate: 'Due date',
      approve: 'Godkjenn',
      disapprove: 'Ikke godkjenn',
      keep: 'Beholde',
      remove: 'Fjerne'
    },
    mixed: {
      scanSerialNumber: 'Skann serienummer',
      noEquipmentFound: 'Ingen utstyr funnet',
      sharedUrl: 'Delt URL',
      checklistfiles: 'Sjekklistefiler',
      attachments: 'Vedlegg',
      signature: 'Signatur',
      nochecklists: 'Ingen sjekklister',
      checklistName: 'Sjekkliste Navn',
      noOfDocuments: 'Nei av dokumenter',
      documentTitle: 'Dokument tittel',
      qrCode: 'QR Kode',
      qrQty: 'QR Quantity',
      irscanner: 'Ir-skanner',
      scanQRCode: 'Skann QR-kode',
      attachmentsBelow: 'Finn vedlegg nedenfor',
      noChemicalFound: 'Ingen kjemikalieliste funnet',
      barCodeNotDecoded: 'Kunne ikke dekode strekkoden fra QR-koden.',
      scanBarcode: 'Skann strekkode'
    },
    chemicallist: {
      chemical: 'Kjemisk',
      provider: 'Forsørger',
      repository: 'Oppbevaringssted',
      last_revised: 'Sist revidert',
      viewChemical: 'Kjemisk',
      chemicalName: 'Kjemisk navn'
    },
    news: {
      news: 'Nyheter',
      next: 'Neste',
      previous: 'Forrige'
    },
    // Production series (WIT-PROTO-PRODSERIES-PWA-001). Copy mirrors the
    // backend's resources/lang/no/production_series.php (key in comment).
    productionSeries: {
      idModeSpool: 'Spool/del nr.', // id_mode_spool
      idModeSeq: 'Uten spool/del nr. — løpenummer', // id_mode_seq
      seriesOf: 'Serie', // series_of
      nWelds: '{n} sveiser', // n_welds
      hasProductionData: 'Har produksjonsdata', // has_production_data
      unitsWelds: '{units} enheter · {welds} sveiser', // units_welds
      unitRetainedSuffix: ' · beholdt', // unit_retained_suffix
      markerDone: '{done}/{total} sveist', // marker_done
      noUnit: 'uten spool/del nr.' // Decision B tag (task copy)
    },
    weldMapping: {
      // 5183 / S18: one batch/heat per welding method.
      methodBatchesLabel: 'Batch/charge per metode',
      methodBatchesHint: 'Denne sveisen bruker mer enn én sveisemetode. Registrer batchen som er brukt for hver.',
      // 5183 / S4: production-series units under a drawing.
      unitsHeading: 'Spool-/delenummer',
      unitScoped: 'Viser spool {unit}',
      unitShowAll: 'Vis alle',
      unsavedHint: 'Ulagrede endringer — bruk knappen under for å forkaste dem',
      batchMissing: 'Batch/charge ikke registrert — fyll inn før du fullfører',
      supersededBy: 'Erstattet av {weld} — registrer reparasjonen på den sveisen',
      previewWps: 'Forhåndsvis WPS',
      comment: 'Kommentar',
      copyMaterial: 'Kopier materiale',
      vtRejectedOn: 'VT avvist på',
      by: 'av',
      reason: 'Årsak:',
      repairOf: 'Reparasjon av',
      wireBatchTitle: 'Sveisetråd · batch/charge',
      batchPf: 'Batch sveisetilsett',
      batchPfHint: 'Skann eller skriv batch…',
      assemblyPf: 'Sammenstilling (PF) sertifikat (valgfritt)',
      weldCertificate: 'Sveisesertifikat',
      certGroupQualified: 'Kvalifisert',
      certGroupCannotVerify: 'Kan ikke verifiseres',
      certGroupNotQualified: 'Ikke kvalifisert',
      certNoneQualified: 'Ingen kvalifiserte sertifikater for denne sveisen',
      certLockedTitle: 'Sveisen er låst — mangler sertifikat',
      certLockedMsg: 'Du har ikke sertifikat som kvalifiserer for denne sveisen. Kontakt sveisekoordinator.',
      certAdvisoryTitle: 'Sertifikat ikke bekreftet',
      certAdvisoryMsg: 'Ingen av sertifikatene dine kunne bekreftes for denne sveisen. Du kan signere — valget blir loggført på sveisen.',
      // WIT-FIX-CERT-5348-001 F5a: the advisory is a not_qualified finding, not cannot_verify.
      certNotQualifiedTitle: 'Ikke dekket av sertifikat',
      // WIT-FIX-CERT-5355-001 F5a / D-5355-3 (Erik 15.10): what none of the welder's certificates covers, then how to go on.
      certNotQualifiedMsg: 'Ingen av dine sertifikater dekker denne sveisen{codes}. Du kan signere med en begrunnelse — sveisekoordinator ser den.',
      certNotQualifiedLead: 'Ingen av dine sertifikater dekker denne sveisen.',
      certSignWithReasonHint: 'Du kan signere med en begrunnelse — sveisekoordinator ser den.',
      certReasonWelder: 'Skriv kort hvorfor du signerer uten kvalifiserende sertifikat (f.eks. «sertifikat ikke registrert ennå»). Sveisekoordinator ser begrunnelsen i sveiseloggen.',
      certNoValidMsg: 'Du har ingen gyldige sveisesertifikater for denne sveisen. Du kan signere — sveisen flagges for sveisekoordinator.',
      certMissingProcess: ' (metode {codes} mangler)',
      // F2: the office override on the sheet (server weld_mapping.cert_ui.override_tip_* twins).
      certOverrideTipReason: 'Begrunnelse: {reason}',
      certOverrideTipBy: 'Av: {by}',
      certOverrideTipAt: 'Når: {at}',
      certAutoHint: 'Velges automatisk fra dine gyldige sertifikater når du trykker «Ferdig sveist».',
      certConfirmTitle: 'Bekreft sertifikat',
      certConfirmBtn: 'Bekreft',
      // WIT-FIX-RETEST-1008-001 P-C: under the confirm intro, only for «Kan ikke verifiseres».
      certConfirmManualNote: 'Valget merkes «Bekreftet manuelt» og vises for sveisekoordinator.',
      // P-C: the chip for a welder's own confirmation (cert_verdict cannot_verify_confirmed).
      certVerdictConfirmed: 'Bekreftet manuelt',
      // P-D: the stop under «Blokker» when nothing the welder holds can apply.
      certBlockedTitle: 'Sveisen kan ikke registreres',
      certOverrideTitle: 'Ikke dekket av sertifikat',
      certOverrideBlock: 'Prosjektet krever kvalifiserende sertifikat. Oppgi en begrunnelse for å signere likevel — sveisekoordinator ser den i sveiseloggen.',
      certOverrideWarn: 'Sveisen signeres og flagges for sveisekoordinator. Du kan legge til en begrunnelse.',
      certReasonLabel: 'Begrunnelse',
      certReasonRequired: 'Begrunnelse må fylles ut.',
      // WIT-FIX-WELDMAP-002 (sertifikater 3.4 / 3.5)
      certRankedTitle: 'Dine sertifikater for denne sveisen:',
      welderIdMissing: 'Sveiser-ID mangler',
      welderIdMissingHint: 'Signert uten sveiser-ID — legg inn sveiser-ID på brukerprofilen din.',
      certSignBtn: 'Signer',
      certLockedOverride: 'Du kan signere med en begrunnelse — sveisekoordinator ser den.',
      certVerdictQualified: 'Kvalifisert',
      certVerdictUnverified: 'Ikke verifisert',
      certVerdictNotQualified: 'Ikke kvalifisert',
      certVerdictNotChecked: 'Ikke kontrollert',
      // WIT-IMPL-CERT-001 P2/P3
      certVerdictOverride: 'Overstyrt',
      certFlaggedToast: 'Signert og flagget for sveisekoordinator.',
      undoSign: 'Angre signering',
      undoSignDone: 'Signeringen av {weld} er angret.',
      // WIT-IMPL-CERT-001 P4 (office picker)
      certShowAllWelders: 'Vis alle sveisere i firmaet',
      certNonParticipant: 'ikke prosjektdeltaker',
      certNonParticipantReason: 'Sveiseren er ikke prosjektdeltaker. Oppgi en begrunnelse — valget lagres som overstyring.',
      noServerAnswer: 'Fikk ikke svar fra serveren. Sjekk nettforbindelsen og prøv igjen — ingenting ble lagret.',
      certMatchChecking: 'Sjekker sertifikater…',
      // WIT-FIX-PWA-WELDERCERT-001 (Erik 09.10.2026): the welder's own picker.
      certAutoPick: 'Velges automatisk · {n} aktuelle',
      certOwnHeading: 'Dine aktuelle sertifikater',
      certOwnHidden: 'Skjult: {n} av dine sertifikater dekker ikke metode/sveisetype.',
      certNoCertificates: 'Du har ingen sveisesertifikat registrert. Kontakt sveisekoordinator.',
      certNoneRelevant: 'Du har ikke sertifikat som kvalifiserer for sveis {weld}. Kontakt sveisekoordinator.',
      assemblyPfHint: 'Velg sertifikat …',
      search: 'Søk',
      nSelected: '{n} valgt',
      assemblyPfNone: 'Ingen sertifikater tilgjengelig',
      batchPfRequired: 'Skriv batch for sveisetilsett for å fullføre sammenstillingen',
      required: 'påkrevd',
      rejectWhy: 'Hvorfor avvises skjøten?',
      rejectNote: 'Merknad (valgfritt)',
      vtLevelIso: 'VT-nivå (ISO 5817)',
      vtLevelFromWeld: 'Satt på sveisen',
      vtLevelOverriding: 'Endrer nivå',
      vtLevelNotSet: 'Ikke satt',
      vtLevels: {
        B: 'Streng',
        C: 'Middels',
        D: 'Moderat'
      },
      faults: {
        undercut: 'Underkutt',
        porosity: 'Porer',
        spatter: 'Sprut',
        fusion: 'Bindefeil',
        geometry: 'Geometri',
        other: 'Annet'
      },
      uploading: 'Laster opp…',
      photoSaved: 'Bilde lagret',
      fromWps: 'fra WPS',
      change: 'Endre',
      batchCharge: 'Batch / chargenr.',
      batchChargeHint: 'Velg batch …',
      batchAdd: 'Legg til',
      batchAddNew: '+ Legg til ny batch …',
      batchGroupWps: 'For denne WPS-en',
      batchTypeNew: 'Annen… (skriv ny batch)',
      batchPickFromList: 'Velg fra listen',
      takePhoto: 'Ta bilde',
      uploadPhoto: 'Last opp bilde',
      signedAs: 'Signert med din bruker',
      title: 'Sveisekartlegging',
      featureDisabled: 'Du har ikke tilgang til Sveisekartlegging.',
      searchDrawing: 'Søk tegning',
      continue: 'Fortsett',
      lastOpened: 'Sist åpnet',
      allDrawings: 'Alle tegninger',
      childDrawings: 'Undertegninger',
      welds: 'skjøter',
      hasChildren: '{count} undertegninger',
      noMatch: 'Ingen tegninger samsvarer',
      noMatchHint: 'Prøv et annet tegningsnummer.',
      mapComingNext: 'Weld map åpnes her i neste steg.',
      drawingsShort: 'Tegninger',
      prevDrawing: 'Forrige tegning: {number}',
      nextDrawing: 'Neste tegning: {number}',
      firstDrawing: 'Første tegning',
      lastDrawing: 'Siste tegning',
      ownJoints: 'Egne skjøter',
      ownMap: 'Åpne weld map for {number}',
      ownSub: '{count} skjøter på selve tegningen',
      joints: 'Skjøter',
      toggleJoints: 'Vis eller skjul skjøtelisten',
      noJoints: 'Ingen skjøter på denne tegningen',
      // Hvilket STADIUM en tegning har nådd (D-5170-1). Nøkkelen kommer fra
      // serveren; ordene hører hjemme her, som resten av kortet.
      drawingStage: {
        pending: 'Ikke startet',
        mapping: 'Under kartlegging',
        mapped: 'Kartlagt',
        welding: 'Under sveising',
        ndt: 'Til kontroll',
        // «VT fullført» (WIT-IMPL-PWA-DRAWINGSTATUS-003): alt sveist og VT
        // signert, men en annen påkrevd NDT-metode gjenstår.
        vt_done: 'VT fullført',
        done: 'Ferdig'
      },
      status: {
        MAPPED: 'Kartlagt',
        FITTED: 'Sammenstilt',
        WELDED: 'Sveist',
        COMPLETED: 'Fullført',
        REPAIR: 'Reparasjon'
      },
      wps: 'WPS',
      process: 'Metode',
      filler: 'Tilsett',
      vtLevel: 'VT-nivå',
      trace: 'Sporing',
      fittedBy: 'Sammenstilt av',
      weldedBy: 'Sveist av',
      vtBy: 'VT av',
      batch: 'batch',
      wire: 'tråd',
      level: 'nivå',
      vtRejectedBy: 'VT avvist av',
      vtPending: 'Venter på VT-kontroll',
      field: {
        title: 'Feltregistrert sveis',
        legend: 'Feltregistrert (venter på kontoret)',
        addBtn: 'Legg til sveis i felt',
        placeHint: 'Trykk på tegningen der den nye sveisen skal plasseres',
        cancel: 'Avbryt',
        queued: '{n} registrering(er) venter på nett',
        syncNow: 'Synk nå',
        wpsDeviation: 'WPS-avvik',
        newTitle: 'Ny sveis – feltregistrert',
        editTitle: 'Endre feltregistrert sveis',
        newSub: 'Registreres av sveiser i felt og flagges for gjennomgang av kontoret.',
        loadingOptions: 'Laster registre…',
        after: 'Etter sveis',
        weldNr: 'Sveisenr.',
        idHint: 'Bokstav + nummeret på foregående sveis: første mellom W-0005 og W-0006 blir A-0005, så B-0005, C-0005 …',
        reason: 'Årsak',
        pickReason: 'Velg årsak…',
        pick: 'Velg…',
        joint: 'Forbindelse',
        groove: 'Fugetype',
        pickGroove: 'Velg fugetype…',
        pickJointFirst: 'Velg forbindelse først',
        pickWps: 'Velg WPS…',
        material: 'Grunnmateriale',
        materialsFailed: 'Kunne ikke laste materialregisteret. Prøv igjen, eller si fra til kontoret.',
        thickness: 'Tykkelse (mm)',
        weldLength: 'Lengde mm',
        spool: 'Spool/del nr.',
        pickSpool: 'Velg spool/del nr.…',
        spoolHint: 'Tegningen har flere spool/del nr. — velg det sveisen står på.',
        validRange: 'gyldig {min}–{max} mm',
        warnNotBlocking: 'Sveisen kan lagres, men avviket flagges for kontoret.',
        warnMaterial: 'Materialet {material} er ikke dekket av {wps}.',
        warnThickness: 'Tykkelse {t} mm er utenfor WPS-ens gyldighetsområde ({min}–{max} mm).',
        // WIT-IMPL-WPS-5324-003 (F4): weld_mapping.field_wps_no_process twin.
        warnNoProcess: 'WPS {wps} mangler sveisemetode – sertifikat kan ikke verifiseres.',
        optional: 'valgfritt',
        notePh: 'F.eks. plassering, avvik, referanse…',
        save: 'Lagre sveis',
        registeredToast: '{weld} registrert — sendes til kontoret for gjennomgang',
        queuedToast: '{weld} lagret på enheten — sendes til kontoret når nettet er tilbake',
        updated: '{weld} oppdatert',
        registered: 'Registrert',
        reviewComment: 'Kommentar fra kontoret',
        office: 'Kontor',
        approve: 'Godkjenn',
        reject: 'Avvis',
        remove: 'Fjern fra tegning',
        edit: 'Endre registrering',
        rejectedNote: 'Avvist av kontoret — fjern den eller registrer sveisen på nytt.',
        localPending: 'Venter på nett — ikke sendt til kontoret ennå.',
        delete: 'Slett registrering',
        deleteConfirm: 'Slette {weld}? Registreringen fjernes fra tegningen og sveiseloggen.',
        deleteHasData: 'Sveisen har produksjonsdata ({status}) og kan ikke slettes her.',
        decision: {
          rejected: 'Avvist av kontoret',
          approved: 'Godkjent av kontoret'
        },
        notifications: 'Varsler',
        noNotifications: 'Ingen varsler',
        status: {
          pending: 'Feltregistrert',
          approved: 'Godkjent',
          rejected: 'Avvist'
        },
        sub: {
          pending: 'venter på godkjenning',
          approved: 'feltregistrert · godkjent',
          rejected: 'avvist av kontoret',
          local: 'venter på synk'
        },
        reasons: {
          missed_in_mapping: 'Glemt i kartlegging',
          unforeseen_pipe_joint: 'Uforutsett rørskjøt',
          site_change: 'Endring på byggeplass',
          other: 'Annet'
        },
        joints: {
          BW: 'BW – Stumpskjøt',
          FW: 'FW – Kilsveis',
          'BW-ROR': 'BW – Rørskjøt'
        },
        grooves: {
          V: 'V-fuge',
          X: 'X-fuge',
          I: 'I-fuge',
          U: 'U-fuge',
          HV: 'HV-fuge',
          J: 'J-fuge',
          FILLET_A: 'Kil (a-mål)'
        },
        notif: {
          field_weld_registered: '{weld} registrert i felt — trenger gjennomgang',
          field_weld_approved: '{weld} godkjent av kontoret',
          field_weld_rejected: '{weld} avvist av kontoret'
        }
      },
      // WIT-IMPL-M101-PWA-001: read-only NDT context per joint (server-derived)
      // and the hold-welding warning carrier. Never a block.
      ndtContext: {
        title: 'NDT-kontekst',
        classDefault: 'Klasse',
        classM101: 'Inspeksjonskategori (NORSOK N-004)',
        classM601: 'NDT-gruppe (NORSOK M-601 tabell 2)',
        jointType: 'Skjøttype',
        weldType: 'Sveisetype',
        penDepth: 's (mm)',
        holdTime: 'Ventetid før NDT',
        earliestNdt: 'Tidligst NDT',
        pending: 'Må avklares',
        status: 'Status',
        hold: {
          pwht: 'ingen (NDT etter PWHT)',
          default_48: '48 t',
          smys_le_355: '24 t (SMYS ≤ 355, dokumentert)',
          smys_le_460_thin: '24 t (SMYS ≤ 460 og t < 40 mm, dokumentert)',
          smys_missing: '48 t (flytegrense mangler)',
          thickness_missing: '48 t (tykkelse mangler)',
          // WIT-FIX-M101-001: table G.1 fixed hold; no SMYS because the material is unlinked.
          g1_fixed_48: '48 t (10.1)',
          material_unlinked: '48 t – materialet er ikke koblet til standardmateriale',
          // WIT-IMPL-SVV-R761-002: NS-EN 1090-2 table 23 (SVV R761).
          table23: '{h} t (NS-EN 1090-2 tabell 23)',
          table23_cooling: 'bare avkjøling (tabell 23)',
          table23_pending: 'må avklares (tabell 23)',
          drawing: '{h} t (tegning)',
          default: '{h} t',
          none: 'ingen registrert'
        }
      },
      weldingHold: {
        flag: 'Sveisestopp',
        wps: 'Sveisestopp på WPS {wps}',
        welder: 'Sveisestopp for sveiseren',
        since: 'siden {date}',
        notBlocking: 'Advarsel – sveisen kan registreres, kontoret er varslet.'
      },
      pendingSync: 'Venter på synk',
      noSymbol: 'Symbol mangler',
      noExecution: 'Ingen utførelse registrert ennå',
      close: 'Lukk',
      noDrawingFile: 'Ingen tegning lastet opp',
      noPreview: 'Forhåndsvisning ikke tilgjengelig',
      imageFailed: 'Kunne ikke laste tegningsbildet',
      roles: {
        fitter: 'Platearbeider',
        welder: 'Sveiser',
        vt: 'VT-kontroll'
      },
      hints: {
        fitter: '{n} skjøter venter på sammenstilling — trykk en blå stiplet markør',
        fitterDone: 'Alle sammenstillinger utført!',
        welder: '{n} klare for sveising — trykk en pulserende markør',
        welderNone: 'Ingen skjøter klare — venter på sammenstilling',
        welderNdt: 'Alle sveiser utført — {n} venter på NDT-kontroll',
        welderDone: 'Alle sveiser utført og kontrollert!',
        vt: '{n} skjøter venter på VT-kontroll — trykk en gull markør',
        vtDone: 'Ingen venter på VT — alt er kontrollert!',
        vtNdtOpen: '{n} VT-godkjent — venter på øvrig NDT (signeres på nettsiden)'
      },
      materials: 'Materialsporing',
      heat: 'Heat/charge',
      heatMissing: 'Mangler heat',
      bulkFitUp: 'Sammenstilt',
      bulkWeldEnd: 'Sveiset',
      bulkWeldList: 'Signerer disse sveisene',
      changeHistory: 'Endringslogg',
      auditField: {
        fillerBatch: 'Sveisebatch',
        batchPf: 'Sammenstillingsbatch',
        filler: 'Tilsett',
        certificateRefs: 'Sveisesertifikat',
        assemblyPf: 'Sammenstillingssertifikat',
        vtLevel: 'VT-nivå',
        // WIT-FIX-CERT-5348-001 F2: the certificate decision in Endringslogg.
        certVerdict: 'Sertifikatkontroll',
        certOverrideReason: 'Begrunnelse for overstyring',
        certUnqualifiedSign: 'Signert uten kvalifiserende sertifikat',
        traceabilityGaps: 'Signert med manglende sporbarhet',
        certRegisteredLater: 'Sertifikat registrert i etterkant'
      },
      auditFrom: 'Fra',
      auditTo: 'Til',
      auditNoChange: 'Lagret uten endringer',
      auditAction: {
        add: 'Lagt til',
        flag: 'Flagget',
        update: 'Endret',
        delete: 'Fjernet'
      },
      posLabel: 'Pos',
      posNrMissing: 'Mangler pos.nr.',
      noMaterials: 'Ingen materialer i planen',
      addMaterial: 'Legg til',
      newMaterial: 'Nytt materiale',
      editMaterial: 'Endre materiale',
      materialHint: 'Skann merket på stålet, eller skriv inn manuelt.',
      scanQr: 'Skann merket (QR)',
      scanNfc: 'RFID/NFC',
      scanComingNext: 'Skanning kommer i et senere steg — skriv inn manuelt under',
      orManual: 'ELLER SKRIV MANUELT',
      materialType: 'Materialtype',
      selectType: 'Velg materialtype',
      editFieldHint: 'Bare feltene du endrer blir lagret. Signatur, dato og VT-kontroll røres ikke.',
      noTypeMatches: 'Ingen treff',
      noTypesInRegister: 'Ingen materialtyper i registeret',
      heatNo: 'Heat / charge-nr',
      heatTypeNew: 'Annen… (skriv nytt heat-nr)',
      heatFromMaterialList: 'Fra materiallisten',
      thickness: 'Tykkelse (mm)',
      posNo: 'Pos nr (bjelke/søyletabell)',
      saveChanges: 'Lagre endringer',
      gapWarnTitle: 'Manglende opplysninger',
      gapWarnHint: 'Denne skjøten mangler opplysninger i materialsporingen. Vil du signere likevel?',
      gapWarnYes: 'Ja, signer likevel',
      gapWarnNo: 'Nei, fyll ut nå',
      gapThickness: 'mangler tykkelse',
      gapType: 'mangler materialtype',
      gapRow: 'Rad {n}',
      bulkSignVt: 'VT-godkjenn alle {n}',
      bulkConfirm: 'Bekreft',
      bulkTitleVt: 'VT-godkjenn alle klare sveiser',
      bulkHint: 'Godkjenner de {n} sveisene som venter på VT-kontroll på denne tegningen. Manglende opplysninger vises etterpå.',
      bulkSigned: '{n} signert',
      bulkSkipped: '{n} hoppet over',
      bulkGapsTitle: 'Mangler i sporingen',
      bulkGapsHint: 'Disse sveisene mangler opplysninger. Du kan godkjenne likevel, eller avbryte og fylle dem ut først.',
      gapHeat: 'mangler heat',
      gapPosNr: 'mangler pos nr',
      gapNoMaterials: 'ingen materialer',
      cancel: 'Avbryt',
      removeMaterial: 'Fjern materiale',
      saving: 'Lagrer…',
      repairNote: 'VT avviste denne — utbedre og registrer på nytt. Ny sveis kobles til original (revisjonssporing).',
      actFitUp: 'Sammenstilling utført',
      actWeld: 'Ferdig sveist',
      actRepair: 'Reparert og sveist',
      actVtOk: 'VT godkjent — nivå {level}',
      actVtReject: 'Avvis — send til reparasjon',
      actionsComingNext: 'Registrering kobles til i neste steg',
      vtSignedNdtOpen: 'VT godkjent — øvrig NDT utestående',
      noAction: 'Ingen {role}-handling på denne skjøten nå ({status})'
    },
    advancedWeldLog: {
      // 5183 / R-2.7c: the production-series column in the weld list.
      spoolNo: 'Spool-/delenr.',
      // 5183 / R-2.7d: route to the weld-mapping screen, where the flow lives.
      addFieldWeld: 'Legg til sveis i felt',
      noDrawingsFound: 'Ingen tegninger funnet',
      folderLIst: 'Mappliste',
      projectDrawings: 'Prosjekttegninger',
      drawingNumber: 'Tegningsnummer',
      weldCount: 'Sveiseantall',
      engineering: 'Ingeniørarbeid',
      production: 'Produksjon',
      ndt: 'NDT',
      pending: 'Avventer',
      inProgress: 'Pågår',
      completed: 'Fullført',
      ndtFaultScope: 'NDT feilområde',
      submit: 'Send inn',
      cancel: 'Avbryt',
      newWeldLog: 'Sveiselogg',
      updateWeldLog: 'Oppdater logg',
      weldNo: 'Sveis nr.',
      jointType: 'Sammenføyningstype',
      wps: 'WPS',
      weldingConsumables: 'Sveisetilsett',
      batchNumber: 'Heat / Batch nr',
      welderCertificates: 'Sveisesertifikat',
      weldEnd: 'Sveising slutt',
      ok: 'Ok',
      sign: 'Signer',
      comments: 'Kommentarer',
      notAcceptable: 'Ikke akseptabelt',
      fault: 'Feil',
      noResultsFound: 'Ingen resultater funnet.',
      drawing: 'Tegning',
      projectName: 'Prosjektnavn',
      aoRanked: 'AO rangert',
      poRanked: 'PO rangert',
      searchWeldLogs: 'Søk etter sveiselogger',
      confirmWeldLogDelete: 'Er du sikker på at du vil slette sveis {weld_nr}?',
      weldingProcess: 'Sveisemetode',
      ndts: 'NDT-er',
      searchDrawings: 'Søk i tegninger',
      selectDrawing: 'Velg en tegning',
      noWeldLogResultsFound: 'Ingen sveiselogger funnet!',
      selectDrawingToLoadWeldLogs: 'Velg en tegning for å laste inn sveiselogger!',
      certificateRequiredWhenWeldEnd: 'Sertifikat er påkrevd når Sveising slutt er valgt.'
    }
  }
}
